import _ from "lodash"

const n0_9 = _.range(0, 10).map((i) => `${i}`);

const unused070: { [key: string]: string[] } = {
  "25": ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
  "34": ["2", "3", "4", "5", "6", "7", "8", "9"],
  "50": ["0"],
  "57": [],
  "58": ["0", "2", "3", "4", "5", "6", "7", "8", "9"],
  "59": [],
  "60": [],
  "63": ["7", "8", "9"],
  "67": [],
  "68": ["6", "7", "8", "9"],
  "80": ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
  "81": [],
  "82": [],
  "85": ["9"],
  "88": ["0", "1", "2", "3", "4",],
}

const usable_prefix = _({
  "090": _(_.range(0, 10)).map((i) => n0_9.map(d => `${i}${d}`)).flatten().value(),
  "080": _(_.range(0, 10)).map((i) => n0_9.map(d => `${i}${d}`)).flatten().value(),
  "070": _(unused070).map((ds, n) => ds.map(d => n + d)).flatten().value(),
}).map((ds, n) => ds.map(d => n + d)).flatten().value();

console.log(usable_prefix);

export function roll_cell_number() {
  const prefix = usable_prefix[Math.floor(Math.random() * usable_prefix.length)];
  const ph = (prefix + "_______________________").substring(0, 11);
  return ph.replace(/_/g, () => `${Math.floor(Math.random() * 10)}`);
}